import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CacheExpiryConstants, CacheKeyConstants, CacheService, isNullOrUndefined } from '@uzurv/core';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RuleValue } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class RuleValueService extends UzurvRestService {
  readonly resourceUrl = 'ruleValues/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer,
    private cacheService: CacheService
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of rule values
   *
   * @param overrideCache
   */
  getRuleValues(overrideCache = false): Observable<Array<RuleValue>> {
    const cachedData = this.cacheService.getCachedData(CacheKeyConstants.RULE_VALUES);
    if (!overrideCache && !isNullOrUndefined(cachedData)) {
      of(Deserialize(JSON.parse(cachedData), RuleValue));
    }

    return this.get(this.resourceUrl, { pageNumber: 0, pageSize: 1000 }).pipe(map(response => {
      this.cacheService.cacheData(CacheKeyConstants.RULE_VALUES, JSON.stringify(response), CacheExpiryConstants.RULE_VALUE_CACHE_EXPIRY);
      return Deserialize(response, RuleValue);
    }));
  }

  /**
   * Returns a rule value by ID
   *
   * @param id
   * @param overrideCache
   */
  findRuleValueWithId(id: number, overrideCache = false): Observable<RuleValue> {
    return this.getRuleValues(overrideCache).pipe(map(response => (response.find(ruleValue => ruleValue.id === id))));
  }

  /**
   * Returns a rule value by name
   *
   * @param name
   * @param overrideCache
   */
  findRuleValueWithName(name: string, overrideCache = false): Observable<RuleValue> {
    return this.getRuleValues(overrideCache).pipe(map(response => (response.find(ruleValue => ruleValue.name === name))));
  }
}
